import Options from '@utils/common/options/module'
const options = new Options('options')
  .add(1, 'docType[0]')
  .add(2, 'docType[1]')
  .add(3, 'docType[2]')
  .add(4, 'docType[3]')
  .add(5, 'docType[4]')
  .add(6, 'docType[5]')
  .add(7, 'docType[6]')
  .add(8, 'docType[7]')
  .add(9, 'docType[8]')
  .add(10, 'docType[9]')
  .add(11, 'docType[10]')
  .add(12, 'docType[11]')
  .add(13, 'docType[12]')
  .add(14, 'docType[13]')
  .add(15, 'docType[14]')
  .add(131, 'docType[15]')
  .add(132, 'docType[16]')
  .add(133, 'docType[17]')
  .add(134, 'docType[18]')

export default options

